/**
 * Renders the app header
 */

import React from 'react';
import { observer } from 'mobx-react';

// Config
import { config } from '../../config';

// Translation
import translate from '../translate/Translate';

// Components
import Accessibility from './Accessibility';

// Icons
import * as icons from '../ui/Icons';
import { getUrlSegment } from '../../helpers';

const Header = observer(
  class Header extends React.Component {

    handleHelp = () => {
      const { store, translation } = this.props;
      const { AppStore } = store;

      const content = {
        heading: translation.help_dialog.heading,
        body: translation.help_dialog.body,
        button: translation.help_dialog.button
      }

      AppStore.showDialog(content, 'wide');
    }

    render() {
      const { store, translation } = this.props;
      const { installSid } = store.UserStore;
      const publicStart = getUrlSegment(1) === 'group';

      return (
        <header className="app-head" aria-labelledby="page-head">
          <h2 className="meta" id="page-head">Page header</h2>
          <a
            className="app-head__skip"
            href="#main-content"
            onClick={e => {
              e.preventDefault();
              const content = document.querySelector('#main-content');
              content && content.focus();
            }}
          >
            {translation.skip_to_content}
          </a>

          <div className="wrap">
            <div className="brand">
              {/* Default WGU logo */}
              {installSid !== config.gereSid &&
                <icons.wguLogo />
              }

              {/* GERE logo for WGU GERE install */}
              {installSid === config.gereSid &&
                <icons.wguGereLogo />
              }
            </div>

            <div className="app-head__tools">
              <Accessibility {...this.props} />

              {installSid !== config.gereSid && !config.customRedirectInstalls.includes(installSid) && !publicStart &&
                <button className="btn" onClick={this.handleHelp}>
                  <icons.questionCircle />
                  {translation.help}
                </button>
              }
            </div>
          </div>
        </header>
      );
    }
  }
);

export default translate('Header')(Header);
